export default "__VITE_ASSET__IRXupihc__"